import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MockupImage } from './MockupImage';
import { TrustLine } from './TrustLine';
import { CHECKOUT_URL, COMPARE_PRICE, PRICE, PRODUCT, PRODUCT_TAGLINE } from '../data/constants';
const INCLUDED = ['6 modules professionnels complémentaires', '5 bonus pratiques (valeur 15 € chacun)', 'Diagnostic électronique & OBD-II (module central)', 'Diagnostic moteur, injection & allumage', 'Diagnostic électrique & électronique automobile', 'Diagnostic transmission & systèmes de transmission', 'Diagnostic freinage, suspension & direction', 'Méthodes de diagnostic, procédures & fiches atelier', 'Méthode SYMPTÔME › CODES › MESURES › HYPOTHÈSE › VALIDATION', 'Accès à vie • livraison numérique immédiate'];
export function Offer() {
  return <section id="offer" className="scroll-mt-2 bg-white py-5 sm:py-7" data-id="element-127" data-mp="2fad4jky754fs">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-128" data-mp="2acbiqs9dyr0m">
        <p className="mx-auto w-fit rounded-md bg-gold px-3 py-1 font-display text-xs font-extrabold uppercase tracking-widest text-navy sm:text-sm" data-id="element-129" data-mp="pk7ctcuai558">
          OFFRE SPÉCIALE DE LANCEMENT
        </p>

        <div className="mt-2 overflow-hidden rounded-2xl border-[3px] border-dashed border-tech bg-white shadow-lg" data-id="element-130" data-mp="zio9mqfwtdz7">
          <div className="bg-navy p-3 text-center sm:p-5" data-id="element-131" data-mp="13ki4gi3fbnrg">
            <h2 className="text-2xl leading-tight text-white sm:text-4xl" data-id="element-132" data-mp="13hnnj0jmcl2s">🔧 {PRODUCT}</h2>
            <p className="mx-auto mt-1 max-w-2xl font-display text-xs font-semibold uppercase leading-tight tracking-wide text-tech-light sm:text-base" data-id="element-133" data-mp="6rmqke93iyae">
              {PRODUCT_TAGLINE}
            </p>
          </div>

          <div className="grid gap-3 p-3 sm:p-6 lg:grid-cols-[0.9fr_1.1fr] lg:items-center lg:gap-6" data-id="element-134" data-mp="kl49bwtyk6zd">
            <MockupImage data-id="element-135" data-mp="3k8lzept6dv0g" />

            <div data-id="element-136" data-mp="3k9fc07etfeqi">
              <p className="font-heading text-lg font-extrabold leading-tight text-navy sm:text-xl" data-id="element-137" data-mp="3k7ufic8xxlq0">
                Système professionnel complet 6 en 1
              </p>
              <ul className="mt-1.5 grid gap-1" data-id="element-138" data-mp="vf7bmbe5q69f">
                {INCLUDED.map(item => <li key={item} className="flex items-start gap-2" data-id="element-139" data-mp="qh5w20fxwp2p">
                    <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-teal" aria-hidden="true" data-id="element-140" data-mp="qetfnrptymrr" />
                    <span className="text-sm font-medium leading-snug text-steel sm:text-base" data-id="element-141" data-mp="106z7n1g3146y">
                      {item}
                    </span>
                  </li>)}
              </ul>

              <div className="mt-3 rounded-xl border-2 border-tech bg-tech-soft px-3 py-2 text-center" data-id="element-142" data-mp="7jmhyiemkg9f">
                <p className="font-display text-sm font-extrabold uppercase leading-tight text-navy sm:text-base" data-id="element-143" data-mp="lfgiad1c1xax">
                  🔥 OBTENEZ {PRODUCT} AUJOURD’HUI —{' '}
                  <span className="text-steel line-through decoration-alert decoration-2" data-id="element-144" data-mp="1wvew0u7gh7ih">
                    {COMPARE_PRICE}
                  </span>{' '}
                  <span className="whitespace-nowrap font-heading text-3xl font-black text-tech sm:text-4xl" data-id="element-145" data-mp="20ex9647o1xvm">
                    {PRICE}
                  </span>
                </p>
              </div>

              <div className="mt-3 flex flex-col items-center" data-id="element-146" data-mp="1qgpuxt4rhtxb">
                <CTAButton href={CHECKOUT_URL} data-id="element-147" data-mp="1qikhfbvolu3i">🔧 OUI ! JE VEUX LE SYSTÈME COMPLET</CTAButton>
                <TrustLine items={['Accès numérique immédiat', '🛡️ Garantie de 7 jours']} data-id="element-148" data-mp="1vft0deonm25t" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}